"use client";

import { Link } from "@/i18n/routing";
import { useCart } from "../cart";
import { useLocale } from "next-intl";
import { PiShoppingCartSimple } from "react-icons/pi";
import { useEffect, useState } from "react";
import { useTranslations } from "next-intl"
import { RiShoppingBagLine } from "react-icons/ri";


export default function CartIcon() {
  const { cart } = useCart();
  const l = useLocale();
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [isMounted, setIsMounted] = useState(false);
    const t = useTranslations('cart-c')
  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (isMounted) {
      setTotalQuantity(cart.reduce((sum, item) => sum + item.quantity, 0));
    }
  }, [cart, isMounted]);

  if (!isMounted) return null; // Prevents hydration mismatch

  return (
    <Link href="/cart" rel="preload" aria-label={t('title-cart')}>
      <div className="relative">
        {cart.length > 0 && (
          l === "ar" ? (
            <span className="absolute -top-1 left-4 flex h-5 w-5 items-center justify-center rounded-full bg-gold text-xs text-white">
              {totalQuantity}
            </span>
          ) : (
            <span className="absolute -top-2 -right-2 flex h-5 w-5 items-center justify-center rounded-full bg-gold text-xs text-white">
              {totalQuantity}
            </span>
          )
        )}
        <RiShoppingBagLine size={24} className="hover:text-gold" />
      </div>
    </Link>
  );
}
